import maplibregl from "maplibre-gl";
import { el } from "../../../utils/el";
import { parseIsoDate } from "../../../utils/dateUtils";

export function createMarkerPopup({
  segment,
  closeOnClick = true,
  offset = 25,
  onClose,
  onDelete,
  onEdit,
  onAddImage,
} = {}) {
  const root = el("div", { className: "ml-popup" }); //document.createElement("div");
  // root.className = "ml-popup";
  // root.innerHTML = `
  //   <div class="ml-popup__header">
  //     <h3 class="ml-popup__title">${title}</h3>
  //     <button class="ml-popup__close" aria-label="Close popup" title="Close">✕</button>
  //   </div>
  //   <div class="ml-popup__body"><div class="ml-popup__desc">${description}</div></div>
  //   <div class="ml-popup__actions">
  //     <button class="ml-btn ml-btn--ghost" data-action="edit"  type="button">Edit</button>
  //     <button class="ml-btn ml-btn--ghost" data-action="image" type="button">Add image</button>
  //     <button class="ml-btn ml-btn--danger" data-action="delete" type="button">Delete</button>
  //   </div>`;

  // header
  const titleEl = renderTitle(segment);
  const puHeaderEl = el("div", { className: "ml-popup__header" });
  const puCloseEl = el(
    "button",
    { className: "ml-popup__close", ariaLabel: "Close popup", title: "Close" },
    "x"
  );

  puHeaderEl.append(titleEl);
  puHeaderEl.append(puCloseEl);

  //body
  const descriptionEl = renderDescription(segment);
  const puBodyEl = el("div", { className: "ml-popup__body" });
  puBodyEl.append(descriptionEl);

  //Footer
  const puActionsEl = renderActions({ onEdit, onAddImage, onDelete });
  const puFooterEl = el("div", { className: "ml-popup__footer" });
  puFooterEl.append(puActionsEl);

  //build root
  root.append(puHeaderEl);
  root.append(puBodyEl);
  root.append(puFooterEl);

  const popup = new maplibregl.Popup({
    closeButton: false,
    closeOnClick,
    offset,
  }).setDOMContent(root);

  root.querySelector(".ml-popup__close")?.addEventListener("click", () => {
    popup.remove();
    onClose?.();
  });

  // root
  //   .querySelector('[data-action="edit"]')
  //   ?.addEventListener("click", () => onEdit?.() || alert("Edit Popup"));
  // root
  //   .querySelector('[data-action="image"]')
  //   ?.addEventListener("click", () => onAddImage?.() || alert("Add Image"));

  // root
  //   .querySelector('[data-action="delete"]')
  //   ?.addEventListener("click", () => alert("Delete Marker"));

  // root
  //   .querySelector('[data-action="delete"]')
  //   ?.addEventListener("click", () => onDelete?.());

  popup.on("close", () => onClose?.());

  return popup;
}

function renderTitle(segment) {
  let titleEl = null;

  switch (segment.type) {
    case "transportation":
      if ((segment.terms || "").toLowerCase() === "hire") {
        titleEl = el("h3", { className: "ml-popup__title" }, [
          segment.providerName + " (" + segment.providerCode + ")",
          el("br", {}),
          [segment?.originName, segment?.destinationName]
            .filter(Boolean)
            .join(" - "),

          // segment?.originCode + " - " + segment?.destinationCode,
        ]);
      } else if ((segment.terms || "").toLowerCase() === "own") {
        titleEl = el("h3", { className: "ml-popup__title" }, [
          `Road Trip!!! ( ${segment.originName} to ${segment.destinationName} )`,
          el("br", {}),
          [segment?.originCode, segment?.destinationCode]
            .filter(Boolean)
            .join(" - "),

          // segment?.originCode + " - " + segment?.destinationCode,
        ]);
      }

      break;
    case "accommodation":
      titleEl = el(
        "h3",
        { className: "ml-popup__title" },
        segment.providerName
      );
      break;
    case "activity":
      // if (segment.mode === "boat")
      titleEl = el(
        "h3",
        { className: "ml-popup__title" },
        segment?.activityName
      ); //segment?.provider || segment?.activityName);
      // else
      //   titleEl = el(
      //     "h3",
      //     { className: "ml-popup__title" },
      //     segment.activityName
      //   );

      break;
    case "tracks":
      titleEl = el("h3", { className: "ml-popup__title" }, "We were here!");
      break;
    default:
      titleEl = el("h4", { className: "ml-popup__title" }, "Info");
      break;
  }

  return titleEl;
}

function renderDescription(segment) {
  const descriptionEl = el("div", { className: "ml-popup_desc" });
  let contentEl = el("div", {});
  switch (segment.type) {
    case "transportation":
      contentEl = el("div", {}, [
        segment.providerName &&
          segment.carType &&
          segment.providerName.toLowerCase() === "self" &&
          el("h4", {}, segment.carType),
        segment.providerName &&
          segment.providerName.toLowerCase() == "self" &&
          el("span", {}, "Road Trip!"),
        segment.confirmation &&
          el("span", {}, [
            el("b", {}, "Confirmation:"),
            " " + segment.confirmation,
          ]),
        segment.confirmation && el("br", {}, []),
        segment.contacts.phone &&
          el("span", {}, [el("b", {}, "Phone:"), " " + segment.contacts.phone]),
        segment.contacts.phone && el("br", {}, []),
        segment.contacts.email &&
          el("span", {}, [
            el("b", {}, "Email:"),
            " ",
            el(
              "a",
              { href: "mailto:" + segment.contacts.email },
              segment.contacts.email
            ),
          ]),
        segment.contacts.email && el("br", {}, []),
        segment.contacts.web &&
          el("span", {}, [
            el("b", {}, "Web:"),
            " ",
            el("a", { href: segment.contacts.web, target: "_blank" }, "Link"),
          ]),
      ]);
      break;
    case "accommodation":
      contentEl = el("div", {}, [
        el("span", {}, segment.contacts.address),
        segment.contacts.phone &&
          el("span", {}, [
            el("b", {}, "Phone:"),
            " " + segment.contacts.phone,
            el("br", {}),
          ]),
        segment.contacts.email &&
          el("span", {}, [
            el("b", {}, "Email:"),
            " ",
            el(
              "a",
              { href: "mailto:" + segment.contacts.email },
              segment.contacts.email
            ),
            el("br", {}),
          ]),
        segment.contacts.web &&
          el("span", {}, [
            el("b", {}, "Web:"),
            " ",
            el("a", { href: segment.contacts.web, target: "_blank" }, "Link"),
            el("br", {}),
          ]),
        el("span", {}, el("b", {}, ["Check In:", el("br", {})])),
        el("span", { class: "popup-indent" }, [
          segment.checkInDate + " " + segment.checkInTime,
          el("br", {}),
        ]),
        el("span", {}, el("b", {}, ["Check Out:", el("br", {})])),
        el("span", { class: "popup-indent" }, [
          segment.checkOutDate + " " + segment.checkOutTime,
          el("br", {}),
        ]),
        segment?.booking?.confirmation &&
          el("span", {}, [
            el("b", {}, "Confirmation:"),
            " " + segment.booking.confirmation,
            el("br", {}),
          ]),
      ]);
      break;
    case "activity":
      contentEl = el("div", {}, [
        segment.providerName &&
          el("span", {}, [
            el("b", {}, "Provider:"),
            " " + segment.providerName,
            el("br", {}),
          ]),
        segment?.booking?.confirmation &&
          el("span", {}, [
            el("b", {}, "Confirmation:"),
            " " + segment.booking.confirmation,
            el("br", {}),
          ]),
        el("span", {}, [
          el("b", {}, ["Starts:", el("br", {})]),
          el("span", {}, [
            `${segment.startDate + " " + segment.startTime}`,
            el("br", {}),
          ]),

          el("b", {}, ["Ends:", el("br", {})]),
          el("span", {}, [
            `${segment.endDate + " " + segment.endTime}`,
            el("br", {}),
          ]),
        ]),

        segment.contacts.phone &&
          el("span", {}, [
            el("b", {}, "Phone:"),
            " " + segment.contacts.phone,
            el("br", {}),
          ]),
        segment.contacts.email &&
          el("span", {}, [
            el("b", {}, "Email:"),
            " ",
            el(
              "a",
              { href: "mailto:" + segment.contacts.email },
              segment.contacts.email
            ),
            el("br", {}),
          ]),
        segment.contacts.web &&
          el("span", {}, [
            el("b", {}, "Web:"),
            " ",
            el("a", { href: segment.contacts.web, target: "_blank" }, "Link"),
            el("br", {}),
          ]),
      ]);
      break;
    case "tracks":
      const udate = segment?.updated
        ? new Date(segment.updated)
        : new Date(segment.updated);

      contentEl = el("div", {}, [
        el("u", {}, "Highlights"),
        el("br", {}),
        el("span", {}, segment.title),
        el("br", {}),
        el(
          "span",
          {},
          udate != undefined && udate != null ? udate.toUTCString() : ""
        ),
      ]);
      break;
    default:
      break;
  }

  //transportation rental
  let rentalEl = el("div", {});
  if (segment.type === "transportation") {
    const rentalFlag = getRentalStatus(segment); //none, booked, incomplete

    if (rentalFlag === "booked" || rentalFlag === "incomplete") {
      const parsedPickupDate = parseIsoDate(segment.pickupDateTime);
      const parsedReturnDate = parseIsoDate(segment.returnDateTime);
      rentalEl = el("div", {}, [
        el("hr", {}, ""),
        el("u", {}, el("label", {}, "Rental Pickup:")),
        el("div", {}, [
          el(
            "span",
            { class: "popup-indent" },
            "  " + parsedPickupDate.yyyyMmDd + " " + parsedPickupDate.shortTime
          ),
          el("br", {}, []),
          el("span", { class: "popup-indent" }, "  " + segment.pickupLocation),
        ]),
        el("u", {}, el("label", {}, "Rental Return:")),
        el("div", {}, [
          el(
            "span",
            { class: "popup-indent" },
            "  " + parsedReturnDate.yyyyMmDd + " " + parsedReturnDate.shortTime
          ),
          el("br", {}, []),
          el("span", { class: "popup-indent" }, "  " + segment.returnLocation),
        ]),
      ]);
    }
  }

  // coordinates
  let coordinatesEl = el("div", {});

  // if (segment.coordinates.departure && segment.coordinates.arrival) {
  //   const parsedArrivalDate = parseIsoDate(segment.arrivalDateTime);
  //   const parsedDepartureDate = parseIsoDate(segment.departureDateTime);

  //   coordinatesEl = el("div", {}, [
  //     el("hr", {}, ""),
  //     el("span", {}, [el("b", {}, "Departure:"), " " + segment.originName]),
  //     el("div", {}, [
  //       el(
  //         "span",
  //         { class: "popup-indent" },
  //         "  " +
  //           parsedDepartureDate.yyyyMmDd +
  //           " " +
  //           parsedDepartureDate.shortTime
  //       ),
  //     ]),
  //     el("span", {}, [el("b", {}, "Arrival:"), " " + segment.destinationName]),
  //     el("div", {}, [
  //       el(
  //         "span",
  //         { class: "popup-indent" },
  //         "  " + parsedArrivalDate.yyyyMmDd + " " + parsedArrivalDate.shortTime
  //       ),
  //     ]),
  //   ]);

  if (segment.coordinates.longitude && segment.coordinates.latitude) {
    //fixed point coordinates
    coordinatesEl = el("div", {}, [
      el("hr", {}, ""),
      el("span", {}, [el("b", {}, "Coordinates:"), " Lat/Long"]),
      el("div", {}, [
        el(
          "span",
          { class: "popup-indent" },
          "  " +
            segment.coordinates.latitude +
            ", " +
            segment.coordinates.longitude
        ),
      ]),
    ]);
  } else if (
    segment?.coordinates?.departure?.longitude &&
    segment?.coordinates?.departure?.latitude &&
    segment?.coordinates?.arrival?.longitude &&
    segment?.coordinates?.arrival?.latitude
  ) {
    coordinatesEl = el("div", {}, [
      el("hr", {}, ""),
      el("span", {}, [el("b", {}, "Coordinates:"), " Lat/Long"]),
      el("div", {}, [
        el("span", {}, "Departure: "),
        el("br", {}),
        el(
          "span",
          { class: "popup-indent" },
          "  " +
            segment.coordinates.departure.latitude +
            ", " +
            segment.coordinates.departure.longitude
        ),
        el("br", {}),
        el("span", {}, "Arrival: "),
        el("br", {}),
        el(
          "span",
          { class: "popup-indent" },
          "  " +
            segment.coordinates.arrival.latitude +
            ", " +
            segment.coordinates.arrival.longitude
        ),
      ]),
    ]);
  }

  // build description
  descriptionEl.append(contentEl);
  descriptionEl.append(rentalEl);
  descriptionEl.append(coordinatesEl);

  return descriptionEl;
}

function renderActions({ onEdit, onAddImage, onDelete }) {
  const actionsEl = el("div", { className: "ml-popup__actions" }, [
    el(
      "button",
      {
        className: "ml-btn ml-btn--ghost",
        dataAction: "edit",
        type: "button",
        addEventListener: [
          "click",
          () => {
            onEdit?.() || alert("Edit");
          },
          false,
        ],
      },
      "Edit"
    ),
    el(
      "button",
      {
        className: "ml-btn ml-btn--ghost",
        dataAction: "image",
        type: "button",
        addEventListener: [
          "click",
          () => {
            onAddImage?.() || alert("Add Image");
          },
          false,
        ],
      },
      "Add Image"
    ),
    el(
      "button",
      {
        className: "ml-btn ml-btn--ghost",
        dataAction: "delete",
        type: "button",
        addEventListener: [
          "click",
          () => {
            onDelete?.() || alert("delete");
          },
          false,
        ],
      },
      "Delete"
    ),
  ]);

  return actionsEl;
}
/**
 *
 * @param {*} segment itinerary segment
 * @returns string none|booked|incomplete
 */
function getRentalStatus(segment) {
  if (!segment.hasOwnProperty("terms") || segment.terms !== "rent")
    return "none";

  const requiredFields = [
    "pickupDateTime",
    "returnDateTime",
    // "pickupTime",
    // "returnTime",
    "pickupLocation",
    "returnLocation",
  ];

  const values = requiredFields.map((field) => segment[field]);

  const allEmpty = values.every((val) => val === "");
  const allFilled = values.every((val) => val !== "");

  if (allEmpty) {
    return "none";
  } else if (allFilled) {
    return "booked";
  } else {
    return "incomplete";
  }
}

// previous working
// import maplibregl from "maplibre-gl";

// export function createMarkerPopup({
//   title = "Marker",
//   description = "No description provided.",
//   closeOnClick = false,
//   offset = 25,
//   onClose,
//   onDelete,
//   onEdit,
//   onAddImage,
// } = {}) {
//   const root = document.createElement("div");
//   root.className = "ml-popup";
//   root.innerHTML = `
//     <div class="ml-popup__header">
//       <h3 class="ml-popup__title">${title}</h3>
//       <button class="ml-popup__close" aria-label="Close popup" title="Close">✕</button>
//     </div>
//     <div class="ml-popup__body"><div class="ml-popup__desc">${description}</div></div>
//     <div class="ml-popup__actions">
//       <button class="ml-btn ml-btn--ghost" data-action="edit"  type="button">Edit</button>
//       <button class="ml-btn ml-btn--ghost" data-action="image" type="button">Add image</button>
//       <button class="ml-btn ml-btn--danger" data-action="delete" type="button">Delete</button>
//     </div>`;
//   const popup = new maplibregl.Popup({
//     closeButton: false,
//     closeOnClick,
//     offset,
//   }).setDOMContent(root);
//   root.querySelector(".ml-popup__close")?.addEventListener("click", () => {
//     popup.remove();
//     onClose?.();
//   });
//   root
//     .querySelector('[data-action="edit"]')
//     ?.addEventListener("click", () => onEdit?.());
//   root
//     .querySelector('[data-action="image"]')
//     ?.addEventListener("click", () => onAddImage?.());
//   root
//     .querySelector('[data-action="delete"]')
//     ?.addEventListener("click", () => onDelete?.());
//   popup.on("close", () => onClose?.());
//   return popup;
// }

// import maplibregl from "maplibre-gl";

// /**
//  * Create a MapLibre Popup with default UI and optional handlers.
//  *
//  * @param {Object} opts
//  * @param {string} [opts.title]           - Heading text
//  * @param {string} [opts.description]     - Description text (HTML allowed, sanitize upstream)
//  * @param {boolean} [opts.closeOnClick]   - Close when clicking the map (default false)
//  * @param {number|Object} [opts.offset]   - Popup offset (default 25)
//  * @param {Function} [opts.onClose]       - Called when popup is closed
//  * @param {Function} [opts.onDelete]      - Called when user clicks "Delete marker"
//  * @param {Function} [opts.onEdit]        - Called when user clicks "Edit marker"
//  * @param {Function} [opts.onAddImage]    - Called when user clicks "Add image"
//  * @returns {maplibregl.Popup}
//  */
// export function createMarkerPopup({
//   title = "Marker",
//   description = "No description provided.",
//   closeOnClick = false,
//   offset = 25,
//   onClose,
//   onDelete,
//   onEdit,
//   onAddImage,
// } = {}) {
//   // Build DOM content (no React dependency needed)
//   const root = document.createElement("div");
//   root.className = "ml-popup";

//   root.innerHTML = `
//     <div class="ml-popup__header">
//       <h3 class="ml-popup__title">${title}</h3>
//       <button class="ml-popup__close" aria-label="Close popup" title="Close">✕</button>
//     </div>
//     <div class="ml-popup__body">
//       <div class="ml-popup__desc">${description}</div>
//     </div>
//     <div class="ml-popup__actions">
//       <button class="ml-btn ml-btn--ghost" data-action="edit"  type="button">Edit</button>
//       <button class="ml-btn ml-btn--ghost" data-action="image" type="button">Add image</button>
//       <button class="ml-btn ml-btn--danger" data-action="delete" type="button">Delete</button>
//     </div>
//   `;

//   // Wire events
//   const btnClose = root.querySelector(".ml-popup__close");
//   const btnEdit = root.querySelector('[data-action="edit"]');
//   const btnImage = root.querySelector('[data-action="image"]');
//   const btnDelete = root.querySelector('[data-action="delete"]');

//   const popup = new maplibregl.Popup({
//     closeButton: false, // we provide our own button for styling
//     closeOnClick,
//     offset,
//   }).setDOMContent(root);

//   btnClose?.addEventListener("click", () => {
//     popup.remove();
//     onClose?.();
//   });
//   btnEdit?.addEventListener("click", () => onEdit?.());
//   btnImage?.addEventListener("click", () => onAddImage?.());
//   btnDelete?.addEventListener("click", () => onDelete?.());

//   // Also surface "close" events triggered externally
//   popup.on("close", () => onClose?.());

//   return popup;
// }
